<main itemscope itemtype="https://schema.org/WebPage">
  <div [innerHTML]="organizationSchema"></div>
  <app-jumbotron></app-jumbotron>

  <header class="container text-center py-4 py-lg-5">
    <h1 class="main-seo-h1" itemprop="headline">
      CAMBEN: Fábrica de **Uniformes Oficiales Adventistas** | Guías Mayores, Conquistadores y Aventureros
    </h1>
    <p class="lead text-muted pt-2 mx-auto" style="max-width: 800px;" itemprop="description">
      Somos la **Fábrica Líder** con **40 años de trayectoria** y tu **tienda única** para todos los **uniformes, insignias y materiales reglamentarios** de los clubes. Garantía de calidad con **Envío GRATIS** en México y **Envíos Internacionales** a toda la División Interamericana (DIA).
    </p>
  </header>
  
  <section class="container my-5" id="club-categories">
    <h2 class="h3 text-center pb-3 seo-h2-categories">Líneas de Uniformes Oficiales por Club: Conquistadores, Aventureros y Guías Mayores</h2>
    
    <div class="row text-center">
      <div class="col-md-4 mb-4" itemprop="mainContentOfPage" itemscope itemtype="https://schema.org/Service">
        <a href="/product" class="card-link-club" itemprop="url">
          <div class="card p-3 shadow-sm club-card">
            <i class="fas fa-crown fa-3x text-warning mb-3"></i> 
            <h3 class="h5 card-title" itemprop="name">Uniformes y Accesorios de Guías Mayores</h3>
            <p class="text-muted" itemprop="description">La línea más completa y reglamentaria para el liderazgo oficial.</p>
          </div>
        </a>
      </div>
      <div class="col-md-4 mb-4" itemprop="mainContentOfPage" itemscope itemtype="https://schema.org/Service">
        <a href="/product" class="card-link-club" itemprop="url">
          <div class="card p-3 shadow-sm club-card">
            <i class="fas fa-map-marked-alt fa-3x text-success mb-3"></i> 
            <h3 class="h5 card-title" itemprop="name">Materiales y Uniformes para Conquistadores</h3>
            <p class="text-muted" itemprop="description">Todo para tu investidura, pañoletas y especialidades de Conquistadores.</p>
          </div>
        </a>
      </div>
      <div class="col-md-4 mb-4" itemprop="mainContentOfPage" itemscope itemtype="https://schema.org/Service">
        <a href="/product" class="card-link-club" itemprop="url">
          <div class="card p-3 shadow-sm club-card">
            <i class="fas fa-star fa-3x text-info mb-3"></i> 
            <h3 class="h5 card-title" itemprop="name">Ropa y Accesorios Oficiales de Aventureros</h3>
            <p class="text-muted" itemprop="description">Uniformes, parches y accesorios cómodos y duraderos para Aventureros.</p>
          </div>
        </a>
      </div>
    </div>
  </section>
  

  <section class="container py-5 bg-light-green" id="why-camben" itemscope itemtype="https://schema.org/AboutPage">
    <div class="row align-items-center">
      <div class="col-lg-6 mb-4 mb-lg-0">
        <h2 class="h3 seo-h2-factory mb-3" itemprop="headline">CAMBEN es Fábrica: Calidad, Durabilidad y Experiencia Textil (40 Años)</h2>
        <p class="text-muted" itemprop="description">
          Con **40 años de trayectoria** en la confección, CAMBEN no es solo una tienda, somos la **fábrica oficial** dedicada a los **uniformes adventistas**. Esto nos permite garantizar la **máxima calidad** en cada hilo y costura. Al comprar directamente a la fábrica, aseguras **el mejor precio** y la **máxima durabilidad reglamentaria**.
        </p>
        <p class="text-muted font-weight-bold">
          <i class="fas fa-check-circle text-success mr-2"></i> **Procesos 100% Mexicanos y Materiales de Alta Resistencia para Clubes.**
        </p>
        <p class="text-muted font-weight-bold">
          <i class="fas fa-check-circle text-success mr-2"></i> **Cumplimiento estricto con los Estándares de la División Interamericana (DIA).**
        </p>
        <a href="/quienes-somos" class="btn btn-warning mt-3">Conoce Nuestra Fábrica y Procesos de Confección</a>
      </div>
      <div class="col-lg-6 text-center">
        <img src="https://storage.googleapis.com/camben-user.appspot.com/3a7f2c12-7d43-4c99-9b28-3c7754f830b8WhatsApp_Image_2024-11-09_at_10.35.27_PM-removebg-preview%20%282%29.png?GoogleAccessId=firebase-adminsdk-sby8y@camben-user.iam.gserviceaccount.com&Expires=19230429120&Signature=PhePuNCE0FeApymm6sqoFjF7FaMPk63XPM%2BGU9blbNpZUWAnUrpieBqWh097fMbc4GMWvRAzLftjfpgfCkl22PMQ2zh5SOH45l%2Bs5i8hsRHpSwkArMwYaIaxTnJU2k5y0Z3aa%2Br3%2FJQgasoI%2FVpGhV8vdysd84hnYeMeIyva%2BKqUpzR%2FBnN5y2XXNFKPRrd%2BwTfVyU9UwlxCCyPW1iu1c5pFYqJQBYa9qQkwIszuHvP4S7J5FiwGTQytjmIPNDAoe93YE7wb2JyqA3CbO5Kh9Qo1fjKJsqnyIpt7%2BJDYSqXg4gk3frfIp9V6BfbPOqgXHKWrGelVpgYyGzcSVgaq5Q%3D%3D" class="img-fluid rounded shadow-lg" alt="Fábrica de Uniformes Adventistas CAMBEN, 40 años de calidad y confección textil">
      </div>
    </div>
  </section>

  
  <div class="container my-5">
    <div class="row">
      <h2 class="h3 text-center seo-h2-products mb-4">Productos Destacados: Camisas, Pañoletas y Especialidades para tu Club</h2>
      
      <div class="d-flex justify-content-center" *ngIf="isLoading">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Cargando productos...</span>
        </div>
      </div>
      <ng-container *ngIf="productList && productList.length>0">
        <div class="col-lg-3 col-md-6 col-6 my-3"
             *ngFor="let item of productList | paginate: { itemsPerPage: 8, currentPage: p }"
             itemscope itemtype="https://schema.org/Product">
          <div class="card border-0 p-3 h-100">
            <img [src]="item.coverImage" class="card-img-top img-fluid product-card-img" [alt]="'Uniforme oficial de ' + item.product + ' para Club de ' + item.category" itemprop="image">
            <div class="card-body">
              <a class="product-meta d-block fs-xs pb-1" itemprop="category">{{ item.category }}</a>
              <h5 class="card-title text-truncate" [routerLink]="['/product',item.id]" itemprop="name">{{ item.product }}</h5>
              <p class="card-text text-truncate" itemprop="description">{{ item.description }}</p>
              <div class="d-flex justify-content-between">
                <div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/Offer">
                  <span class="text-accent" itemprop="price">{{ item.priceShop |currency }}</span>
                  <meta itemprop="priceCurrency" content="MXN">
                  <link itemprop="url" [href]="['/product',item.id]">
                  <meta itemprop="availability" content="https://schema.org/InStock">
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
    <div class="row">
      <ng-container *ngIf="productList && productList.length===0">
        <div class="col-4 my-auto mx-auto">
          <img src="../../assets/undraw_empty_xct9.svg" class="img-fluid" alt="No hay productos disponibles actualmente en la tienda CAMBEN">
        </div>
      </ng-container>

    </div>
    <div class="col-md-4 mx-auto my-4">
      <ng-container *ngIf="productList && productList.length>0">
        <pagination-controls (pageChange)="p = $event"></pagination-controls>
      </ng-container>
    </div>
  </div>

  <div class="container mb-5">
    <div class="text-center pt-5">
      <a [routerLink]="['/product']" class="btn btn-lg btn-primary">Ver Catálogo Completo de Uniformes Oficiales Adventistas</a>
    </div>
  </div>

  <section class="container py-5" id="authority-text">
    <h3 class="h4 mb-3 seo-h3-authority">Nuestra Garantía: 40 Años de Confección Exclusiva y Reglamento DIA</h3>
    <div class="row">
        <div class="col-lg-12">
            <p class="text-muted">
                Desde **1985**, CAMBEN ha sido más que un proveedor; somos una parte fundamental de la identidad de los Clubes Adventistas en México e Interamérica. Nuestra especialización como **fábrica textil** nos permite controlar cada etapa, desde la selección de telas de alta durabilidad (Drill, Gabardina, etc.) hasta el bordado de insignias y parches **reglamentarios**. Esta dedicación asegura que cada uniforme de **Guía Mayor, Conquistador o Aventurero** cumpla con los **estándares oficiales de la División Interamericana (DIA)**. Al elegir CAMBEN, no solo compra un uniforme, invierte en un producto de calidad superior y apoya la manufactura 100% mexicana.
            </p>
            <p class="text-muted font-weight-bold">
                <i class="fas fa-certificate text-warning mr-2"></i> **Exige la calidad de fábrica, exige CAMBEN. ¡La durabilidad está garantizada!**
            </p>
        </div>
    </div>
</section>
  
  
  <section class="container py-lg-4 mb-4">
    <h2 class="h3 text-center pb-4 seo-h2-brands">Clubes y Distribuidores: **Nuestros Clientes** | Gracias por su Confianza</h2>
    <div class="row">
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fiasd7_20251014_011811.png?generation=1760404693061293&alt=media" style="width: 150px;" alt="Iglesia Adventista del Séptimo Día (IASD) - Cliente CAMBEN">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fsoriana_20251014_011943.png?generation=1760404783697296&alt=media" style="width: 150px;" alt="Soriana - Cliente de uniformes y materiales promocionales">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Floram_20251014_012102.jpeg?generation=1760404862593213&alt=media" style="width: 150px;" alt="Loram - Cliente de uniformes industriales">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Funiversidadnavojoa_20251014_012256.png?generation=1760404977143260&alt=media" style="width: 150px;" alt="Universidad de Navojoa - Cliente CAMBEN">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Funiversidaddemontemorelos_20251014_012343.png?generation=1760405024303157&alt=media" style="width: 150px;" alt="Universidad de Montemorelos - Cliente de uniformes y ropa deportiva">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fsmart_20251014_012605.png?generation=1760405165866376&alt=media" style="width: 150px;" alt="SMART - Cliente de uniformes y artículos bordados">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fparisina_20251014_012625.png?generation=1760405186138486&alt=media" style="width: 150px;" alt="La Parisina - Distribuidor textil y cliente de confección">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Funiversidadautonomadenuevoleon_20251014_012816.png?generation=1760405297131298&alt=media" style="width: 150px;" alt="Universidad Autónoma de Nuevo León (UANL) - Cliente de uniformes institucionales">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Ffycsa_20251014_012938.jpeg?generation=1760405378612616&alt=media" style="width: 150px;" alt="FYCSA - Cliente de uniformes y material de seguridad">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fcarrier_20251014_013140.png?generation=1760405500842231&alt=media" style="width: 150px;" alt="Carrier - Cliente de uniformes corporativos">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Flogo-universidad-linda-vista_20251014_013242.webp?generation=1760405563435366&alt=media" style="width: 150px;" alt="Universidad Linda Vista - Cliente de uniformes y mercancía oficial">
        </a>
      </div>
      <div class="col-md-3 col-sm-4 col-6">
        <a class="d-block bg-white shadow-sm rounded-3 my-3 py-3 py-sm-4 mb-grid-gutter" href="#">
          <img class="d-block mx-auto" src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Finstitutovicentesuarez_20251014_013344.jpeg?generation=1760405624942472&alt=media" style="width: 150px;" alt="Instituto Vicente Suárez - Cliente de uniformes escolares">
        </a>
      </div>
    </div>
  </section>

  
  <section class="faq-section" id="faq-section">
    <div class="container" itemscope itemtype="https://schema.org/FAQPage">
      <h2 class="main-title">Preguntas Frecuentes sobre Uniformes Adventistas</h2>
      <p class="section-description">
        Aquí resolvemos las dudas más comunes sobre nuestros productos oficiales, cumplimiento reglamentario, envíos y más.
      </p>
  
      <div class="accordion-container">
        
        <div class="faq-item" [class.open]="faqState[0].open" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <div class="faq-question" (click)="toggleFaq(0)">
            <h3 itemprop="name">¿Los uniformes de CAMBEN cumplen con el reglamento oficial de la DIA?</h3>
            <span class="toggle-icon">{{ faqState[0].open ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" [class.visible]="faqState[0].open" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <p itemprop="text">
              ¡Sí, al 100%! Todos nuestros uniformes (Guías Mayores, Conquistadores y Aventureros), insignias, pañoletas y accesorios son confeccionados siguiendo estrictamente las especificaciones y lineamientos oficiales de la **División Interamericana (DIA)** y la **Asociación General (AG)**. Garantizamos el color, la tela y el diseño correctos.
            </p>
          </div>
        </div>

        <div class="faq-item" [class.open]="faqState[1].open" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <div class="faq-question" (click)="toggleFaq(1)">
            <h3 itemprop="name">¿Cómo funciona el Envío GRATIS y a dónde realizan envíos internacionales?</h3>
            <span class="toggle-icon">{{ faqState[1].open ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" [class.visible]="faqState[1].open" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <p itemprop="text">
              Ofrecemos **Envío GRATIS** en pedidos mayores a cierto monto dentro de México. Para envíos internacionales, llegamos a toda Interamérica y más allá. Usamos tarifas preferenciales para asegurar que los clubes de todo el mundo tengan acceso a uniformes de fábrica a precios justos.
            </p>
          </div>
        </div>
        
        <div class="faq-item" [class.open]="faqState[2].open" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <div class="faq-question" (click)="toggleFaq(2)">
            <h3 itemprop="name">¿Por qué es mejor comprar directamente a la Fábrica CAMBEN?</h3>
            <span class="toggle-icon">{{ faqState[2].open ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" [class.visible]="faqState[2].open" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <p itemprop="text">
              Comprar directamente a la fábrica elimina intermediarios, lo que se traduce en **el mejor precio** para usted. Además, controlamos la calidad de inicio a fin (40 años de experiencia), asegurando **mayor durabilidad** y el uso exclusivo de **materiales oficiales de alta resistencia**.
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </section>

  
  <section class="container py-5 text-center bg-dark-blue text-white" id="envios-globales">
    <h2 class="h3 mb-3 text-warning">¡Envíos Internacionales Rápidos a toda la División Interamericana (DIA)!</h2>
    <p class="lead">
      Llevamos la calidad de la **Fábrica CAMBEN** a **clubes de Conquistadores, Aventureros y Guías Mayores de todo el mundo**. Olvídate de intermediarios y costos altos. Somos tu solución directa para **uniformes Adventistas** con alcance global en la División Interamericana (DIA).
    </p>
    <a href="/encuesta" class="btn btn-lg btn-light mt-3">¡Consulta tu Envío Internacional Hoy Mismo!</a>
  </section>

</main>